/** Menú del admin (también define los permisos por ruta de `PermisosGuard`). */
export const RUTA_MENU_ADMIN = '/menu?idAplicacion=2';
